export default {
    PtCustomFieldLabelPane: {
        fieldMainType: {
            public: '企业自定义字段',
            self: '个人自定义字段',
            shared: '来自分享空间的自定义字段',
        },
        filter: {
            searchFieldPlaceholder: '查找自定义字段',
            noFilterData: '无结果',
            noDataToCreate: '您还没有自定义字段，<a href="{href}" target="_blank" rel="noopener">现在创建</a>',
            noData: '您还没有自定义字段',
        },
        render: {
            noData: {
                DATE: '请选择',
                NUM: '添加',
                LAYER: '请选择',
                URL: '添加',
                OPTION: '请选择',
                STRING: '添加',
            },
        },
        editor: {
            placeholder: {
                DATE: '选择日期',
                NUM: '请输入数值',
                LAYER: '选择已有节点',
                URL: '请输入URL地址',
                OPTION: '选择已有选项',
                STRING: '请输入文本',
            },
            validator: {
                NUM: {
                    VALID: '请输入合法数值',
                },
            },
            filter: {
                OPTION: {
                    noFilterData: '没有匹配到相关选项',
                    noData: '该字段无选项',
                },
                LAYER: {
                    noFilterData: '没有匹配到相关节点',
                    noData: '该字段无节点',
                },
            },
        },
        multiLines: {
            more: '更多',
            less: '收起',
        },
        pin: {
            pin: '固定在列表前',
            unPin: '取消固定',
        },
        spaceScopeFieldTip: '标引值仅对当前空间生效',
        spaceScopeEditTip: '非全局自定义字段仅支持在工作空间内进行标引',
        iconCheck: '校验 AI 标引',
        readAsCheck: '修改标引值可完成对 AI 标引的校验',
    },
};
